import { axiosInstance } from "./client";
import { TranslatableEnum } from "@rumble-it/common-lib/types/models/TranslatableEnum.interface";

export const getPaymentByTypes = async () =>
  axiosInstance
    .get<TranslatableEnum[]>(`/dossiers/payment-by-type`)
    .then((response) => response.data);
